import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/app/providers/auth/authContext';
import { routePaths } from '@/app/router/routePaths';
import { LoadingScreen } from '@/shared/ui/LoadingScreen';
import { PageState } from '@/shared/ui/PageState';

/**
 * Gate for the tournament director's area.
 *
 * The role comes from the ID token claim. There is deliberately no way to
 * unlock this from the frontend, and hiding the routes is not what protects
 * the data — the security rules are.
 */
export function RequireAdmin() {
  const { session } = useAuth();
  const location = useLocation();

  if (session.status === 'loading') {
    return <LoadingScreen label="Berechtigung wird geprüft …" />;
  }

  if (session.status === 'anonymous') {
    return <Navigate to={routePaths.login} state={{ from: location.pathname }} replace />;
  }

  if (session.account.role !== 'admin') {
    return (
      <PageState
        title="Kein Zugriff"
        description="Dieser Bereich ist der Turnierleitung vorbehalten. Die Freischaltung erfolgt nicht über die Anwendung."
        action={
          <Link
            to={routePaths.home}
            className="bg-surface-raised hover:bg-surface-overlay border-line touch-target rounded-lg border px-5 py-3 font-medium transition-colors"
          >
            Zur Startseite
          </Link>
        }
      />
    );
  }

  return <Outlet />;
}
